import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Alert,
  CardBody,
  Card
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { maxLength, multiEmail, required } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import Select from 'react-select';
import axiosInstance from '@src/axios-instance';
import LenderPreview from './LenderPreview/LenderPreview';
import LenderModalForm from '@src/components/Lenders/LenderModal/LenderModalForm/LenderModalForm';

const fieldValidator = {
  loan_number_1: [value => maxLength(value, 64)],
  mortgage_id_1: [],
  loan_number_2: [value => maxLength(value, 64)],
  mortgage_id_2: [],
  loan_number_3: [value => maxLength(value, 64)],
  mortgage_id_3: [],
  escrow_number: [value => maxLength(value, 128)]
};

const fieldLenderValidator = {
  name: [required, value => maxLength(value, 255)],
  lpc: [value => maxLength(value, 64)],
  contact_name: [value => maxLength(value, 255)],
  email: [multiEmail, value => maxLength(value, 255)],
  phone: [value => maxLength(value, 64)],
  fax: [value => maxLength(value, 64)],
  address_line_1: [value => maxLength(value, 255)],
  address_line_2: [value => maxLength(value, 255)],
  city: [value => maxLength(value, 255)],
  state: [value => maxLength(value, 64)],
  zip_code: [value => maxLength(value, 32)]
};

class MortgagesModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value: props.entity[key] !== null ? props.entity[key] : '',
        visited: false,
        error: false
      };
    });

    const lender1 = {};
    const lender2 = {};
    const lender3 = {};
    Object.keys(fieldLenderValidator).forEach(key => {
      lender1[key] = {
        value: '',
        visited: false,
        error: false
      };
      lender2[key] = {
        value: '',
        visited: false,
        error: false
      };
      lender3[key] = {
        value: '',
        visited: false,
        error: false
      };
    });
    fields.lender1 = lender1;
    fields.lender2 = lender2;
    fields.lender3 = lender3;

    this.state = {
      ...fields,
      lenders: [],
      inputValue: '',
      newForm1: false,
      newForm2: false,
      newForm3: false
    };
    this.getLenders();
  }

  getAddress = lender => {
    const address = [];
    if (lender.address_line_1 !== null && lender.address_line_1.length > 0) {
      address.push(lender.address_line_1);
    }
    if (lender.address_line_2 !== null && lender.address_line_2.length > 0) {
      address.push(lender.address_line_2);
    }
    if (lender.city !== null && lender.city.length > 0) {
      address.push(lender.city);
    }
    if (lender.state !== null && lender.state.length > 0) {
      address.push(lender.state);
    }
    if (lender.zip_code !== null && lender.zip_code.length > 0) {
      address.push(lender.zip_code);
    }
    return address.join(', ');
  };

  getLenders = () => {
    axiosInstance()
      .get(`/lenders/full-list.json`)
      .then(response => {
        const fields = {};
        let address = '';
        for (let index of ['mortgage_id_1', 'mortgage_id_2', 'mortgage_id_3']) {
          let tmp = response.data.find(o => o.id === this.props.entity[index]);
          if (
            this.props.entity[index] !== null &&
            this.props.entity[index] > 0
          ) {
            address = this.getAddress(tmp);
            fields[index] = {
              value: {
                value: tmp.id,
                label: tmp.name + ' - ' + address,
                object: tmp
              },
              visited: false,
              error: false
            };
          }
        }

        this.setState({
          lenders: response.data,
          ...fields
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event === null
          ? ''
          : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  updateNewForm = (event, name, lenderType) => {
    const formData = JSON.parse(JSON.stringify(this.state[lenderType]));

    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event === null
          ? ''
          : event,
      visited: true,
      error: false
    };

    const validator = fieldLenderValidator;
    for (let i = 0; i < validator[name].length; i++) {
      const validationMsg = validator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    formData[name] = inputData;
    this.setState({
      [lenderType]: formData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] =
        formData[key].value.value !== undefined
          ? formData[key].value.value
          : formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    // Validate new form
    let newData = {};
    let newPostData = {};
    if (this.state.newForm1) {
      newData = JSON.parse(JSON.stringify(this.state.lender1));
      newPostData = {};
      Object.keys(fieldLenderValidator).forEach(key => {
        newPostData[key] =
          newData[key].value.value !== undefined
            ? newData[key].value.value
            : newData[key].value;
        for (let i = 0; i < fieldLenderValidator[key].length; i++) {
          const validationMsg = fieldLenderValidator[key][i](
            newData[key].value
          );
          newData[key].visited = true;
          if (validationMsg !== undefined) {
            newData[key].error = validationMsg;
            isValid = false;
            break;
          } else {
            newData[key].error = false;
          }
        }
      });
      formData['lender1'] = newData;
      postData['lender1'] = newPostData;
    }
    if (this.state.newForm2) {
      newData = JSON.parse(JSON.stringify(this.state.lender2));
      newPostData = {};
      Object.keys(fieldLenderValidator).forEach(key => {
        newPostData[key] =
          newData[key].value.value !== undefined
            ? newData[key].value.value
            : newData[key].value;
        for (let i = 0; i < fieldLenderValidator[key].length; i++) {
          const validationMsg = fieldLenderValidator[key][i](
            newData[key].value
          );
          newData[key].visited = true;
          if (validationMsg !== undefined) {
            newData[key].error = validationMsg;
            isValid = false;
            break;
          } else {
            newData[key].error = false;
          }
        }
      });
      formData['lender2'] = newData;
      postData['lender2'] = newPostData;
    }
    if (this.state.newForm3) {
      newData = JSON.parse(JSON.stringify(this.state.lender3));
      newPostData = {};
      Object.keys(fieldLenderValidator).forEach(key => {
        newPostData[key] =
          newData[key].value.value !== undefined
            ? newData[key].value.value
            : newData[key].value;
        for (let i = 0; i < fieldLenderValidator[key].length; i++) {
          const validationMsg = fieldLenderValidator[key][i](
            newData[key].value
          );
          newData[key].visited = true;
          if (validationMsg !== undefined) {
            newData[key].error = validationMsg;
            isValid = false;
            break;
          } else {
            newData[key].error = false;
          }
        }
      });
      formData['lender3'] = newData;
      postData['lender3'] = newPostData;
    }

    this.setState({ ...formData });

    if (isValid) {
      this.props.onSubmit(postData, null);
    }
    return false;
  };

  render = () => {
    const optionTypes = [];
    let address = '';
    const { lenders, inputValue } = this.state;
    if (inputValue.length > 1) {
      Object.keys(lenders).map(index => {
        address = this.getAddress(lenders[index]);
        if (
          (lenders[index].name + address)
            .toLowerCase()
            .indexOf(inputValue.toLowerCase()) !== -1 &&
          optionTypes.length < 1000
        ) {
          optionTypes.push({
            value: lenders[index].id,
            label: lenders[index].name + ' - ' + address,
            object: lenders[index]
          });
        }

        return false;
      });
    }

    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {'Edit Mortgages / Additional Interest'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              {this.props.errorUnit && (
                <Alert color={'danger'}>{this.props.errorUnit}</Alert>
              )}
              <Row>
                <Col xs={12}>
                  <LabelInput
                    name={'Escrow #'}
                    type={'text'}
                    {...this.state.escrow_number}
                    onChange={event => this.updateForm(event, 'escrow_number')}
                  />
                </Col>
                <Col xs={12}>
                  <LabelInput
                    name={'1st Loan #'}
                    type={'text'}
                    {...this.state.loan_number_1}
                    onChange={event => this.updateForm(event, 'loan_number_1')}
                  />
                </Col>
                <Col xs={12}>
                  <React.Fragment>
                    <Row>
                      <Col xs={7}>
                        <div className={'form-group'}>
                          <label className={'font-weight-bold'}>Lender</label>
                          <Select
                            value={this.state.mortgage_id_1.value}
                            options={optionTypes}
                            onChange={event =>
                              this.updateForm(event, 'mortgage_id_1')
                            }
                            onInputChange={inputValue =>
                              this.setState({ inputValue })
                            }
                            placeholder={'Type to search...'}
                            isClearable
                          />
                        </div>
                      </Col>
                      <Col xs={1} className={'text-center pt-2 mx-0'}>
                        <label className={'mb-1 d-block'}>&nbsp;</label>
                        or
                      </Col>
                      <Col xs={4} className={'text-center btn-block'}>
                        <label className={'mb-1'}>&nbsp;</label>
                        <Button
                          color={'primary'}
                          className={'btn-block'}
                          onClick={() =>
                            this.setState({
                              newForm1: true,
                              mortgage_id_1: {
                                value: '',
                                visited: true,
                                error: false
                              }
                            })
                          }
                        >
                          {'Create New Lender'}
                        </Button>
                      </Col>
                    </Row>
                  </React.Fragment>
                </Col>
                {this.state.newForm1 && (
                  <Col xs={12} className={'pb-2'}>
                    <Card>
                      <CardBody>
                        <LenderModalForm
                          state={this.state.lender1}
                          updateForm={(event, name) =>
                            this.updateNewForm(event, name, 'lender1')
                          }
                        />
                      </CardBody>
                    </Card>
                  </Col>
                )}
                {!this.state.newForm1 &&
                  typeof this.state.mortgage_id_1.value === 'object' &&
                  this.state.mortgage_id_1.value.value > 0 && (
                    <Col xs={12}>
                      <Card>
                        <CardBody>
                          <LenderPreview
                            {...this.state.mortgage_id_1.value.object}
                            link={true}
                            target={'_blank'}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  )}
              </Row>
              <hr />
              <Row>
                <Col xs={12}>
                  <LabelInput
                    name={'2nd Loan #'}
                    type={'text'}
                    {...this.state.loan_number_2}
                    onChange={event => this.updateForm(event, 'loan_number_2')}
                  />
                </Col>
                <Col xs={12}>
                  <React.Fragment>
                    <Row>
                      <Col xs={7}>
                        <div className={'form-group'}>
                          <label className={'font-weight-bold'}>Lender</label>
                          <Select
                            value={this.state.mortgage_id_2.value}
                            options={optionTypes}
                            onChange={event =>
                              this.updateForm(event, 'mortgage_id_2')
                            }
                            onInputChange={inputValue =>
                              this.setState({ inputValue })
                            }
                            placeholder={'Type to search...'}
                            isClearable
                          />
                        </div>
                      </Col>
                      <Col xs={1} className={'text-center pt-2 mx-0'}>
                        <label className={'mb-1 d-block'}>&nbsp;</label>
                        or
                      </Col>
                      <Col xs={4} className={'text-center btn-block'}>
                        <label className={'mb-1'}>&nbsp;</label>
                        <Button
                          color={'primary'}
                          className={'btn-block'}
                          onClick={() =>
                            this.setState({
                              newForm2: true,
                              mortgage_id_2: {
                                value: '',
                                visited: true,
                                error: false
                              }
                            })
                          }
                        >
                          {'Create New Lender'}
                        </Button>
                      </Col>
                    </Row>
                  </React.Fragment>
                </Col>
                {this.state.newForm2 && (
                  <Col xs={12} className={'pb-2'}>
                    <Card>
                      <CardBody>
                        <LenderModalForm
                          state={this.state.lender2}
                          updateForm={(event, name) =>
                            this.updateNewForm(event, name, 'lender2')
                          }
                        />
                      </CardBody>
                    </Card>
                  </Col>
                )}
                {!this.state.newForm2 && this.state.mortgage_id_2.value !== '' && (
                  <Col xs={12}>
                    <Card>
                      <CardBody>
                        <LenderPreview
                          {...this.state.mortgage_id_2.value.object}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
              <hr />
              <Row>
                <Col xs={12}>
                  <LabelInput
                    name={'3rd Loan #'}
                    type={'text'}
                    {...this.state.loan_number_3}
                    onChange={event => this.updateForm(event, 'loan_number_3')}
                  />
                </Col>
                <Col xs={12}>
                  <React.Fragment>
                    <Row>
                      <Col xs={7}>
                        <div className={'form-group'}>
                          <label className={'font-weight-bold'}>Lender</label>
                          <Select
                            value={this.state.mortgage_id_3.value}
                            options={optionTypes}
                            onChange={event =>
                              this.updateForm(event, 'mortgage_id_3')
                            }
                            onInputChange={inputValue =>
                              this.setState({ inputValue })
                            }
                            placeholder={'Type to search...'}
                            isClearable
                          />
                        </div>
                      </Col>
                      <Col xs={1} className={'text-center pt-2 mx-0'}>
                        <label className={'mb-1 d-block'}>&nbsp;</label>
                        or
                      </Col>
                      <Col xs={4} className={'text-center btn-block'}>
                        <label className={'mb-1'}>&nbsp;</label>
                        <Button
                          color={'primary'}
                          className={'btn-block'}
                          onClick={() =>
                            this.setState({
                              newForm3: true,
                              mortgage_id_3: {
                                value: '',
                                visited: true,
                                error: false
                              }
                            })
                          }
                        >
                          {'Create New Lender'}
                        </Button>
                      </Col>
                    </Row>
                  </React.Fragment>
                </Col>
                {this.state.newForm3 && (
                  <Col xs={12} className={'pb-2'}>
                    <Card>
                      <CardBody>
                        <LenderModalForm
                          state={this.state.lender3}
                          updateForm={(event, name) =>
                            this.updateNewForm(event, name, 'lender3')
                          }
                        />
                      </CardBody>
                    </Card>
                  </Col>
                )}
                {!this.state.newForm3 && this.state.mortgage_id_3.value !== '' && (
                  <Col xs={12}>
                    <Card>
                      <CardBody>
                        <LenderPreview
                          {...this.state.mortgage_id_3.value.object}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default MortgagesModal;
